export { default } from "./checkmark";
export type { CheckmarkSize, CheckmarkTone } from "./checkmark";
